import { ValidationError } from '../../gs-core/common';

export type Sort = 'lastUsedDate' | 'title' | 'timesUsed';
export type SortDir = 'asc' | 'desc';

export const SortTypes = {
  lastUsedDate: 'lastUsedDate' as Sort,
  title: 'title' as Sort,
  timesUsed: 'timesUsed' as Sort,

  default(): Sort { return this.lastUsedDate; },

  all(): Sort[] {
    return Object
      .keys(this)
      .filter(key => typeof this[key] === 'string') as Sort[];
  },

  parse(sortBy: string | undefined): Sort | undefined {
    if (!sortBy) {
      return undefined;
    }

    if (!this.all().includes(sortBy as Sort)) {
      throw new ValidationError(`Invalid sort by ${sortBy}`);
    }

    return this[sortBy];
  },

  parseDir(sortDir: SortDir | undefined): SortDir | undefined {
    if (!sortDir) {
      return undefined;
    }

    return sortDir === 'asc' ? 'asc' : 'desc';
  },

  toggleDir(sortDir: SortDir | undefined): SortDir | undefined {
    return sortDir === 'asc' ? 'desc' : 'asc';
  },

  display(titleSort: Sort): string {
    if (titleSort === SortTypes.title) {
      return 'By title';
    }
    if (titleSort === SortTypes.timesUsed) {
      return 'By count';
    }

    return 'By most recent';
  }
};



// WEBPACK FOOTER //
// ./src/common/models/Sort.ts